import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { lastValueFrom } from 'rxjs';
import { SettingsService } from '../settings/settings.service';
import { UsersService } from '../users/users.service';

@Injectable({
  providedIn: 'root',
})
export class ToolBoxService {
  today = new Date();
  year = this.today.getFullYear();

  constructor(
    private _translateService: TranslateService,
    private _localStorageService: LocalStorageService,
    private _settingsService: SettingsService,
    private _userService: UsersService
  ) {}

  hideTableColumn(
    columnToHide: string,
    tableColumns: string[],
    hiddenColumns: string[]
  ): [string[], string[]] {
    if (
      tableColumns.includes(columnToHide) &&
      !hiddenColumns.includes(columnToHide)
    ) {
      if (!tableColumns.includes('expand')) {
        tableColumns.push('expand');
      }
      hiddenColumns.push(
        tableColumns.splice(tableColumns.indexOf(columnToHide), 1)[0]
      );
    }
    return [tableColumns, hiddenColumns];
  }

  hideTableColumnWithoutExpand(
    columnToHide: string,
    tableColumns: string[]
  ): string[] {
    if (tableColumns.includes(columnToHide)) {
      tableColumns.splice(tableColumns.indexOf(columnToHide), 1);
    }
    return tableColumns;
  }

  canShowNextYear(): boolean {
    return this.getCurrentMonth() < 7 && this.getCurrentMonth() > 3
  }

  getCurrentSchoolYear() {
    if (this.getCurrentMonth() < 7) {
      return `${this.year - 1} / ${this.year}`;
    } else {
      return this.getNextSchoolYear();
    }
  }

  getNextSchoolYear() {
    return `${this.year} / ${this.year + 1}`;
  }

  getCustomSchoolYear(year: number) {
    return `${year} / ${year + 1}`;
  }
  
  getCurrentMonth() {
    const month = this.today.getMonth() + 1;
    return month;
  }

  formatYear(schoolYear: string) {
    const [startYear, endYear] = schoolYear.split(' / ').map(year => year.substring(2));
    return `${startYear}-${endYear}`;
  }

  getCurrentLanguage(): string {
    return this._translateService.currentLang + "-CH";
  }

   async getUserEtablissement(): Promise<string> {
      if (this._localStorageService.getItem<string>('userDefaultGE') === null) {
        await lastValueFrom(
          this._settingsService.getUserSettings(this._userService.currentUserValue.oid)
        ).then(us => {
          if (us !== null) {
            return us.defaultGE;
          } else {
            return this._userService.currentUserValue.groupEtablissement[0];
          }
        });
      } else {
        return this._localStorageService.getItem<string>('userDefaultGE');
      }
    }
}
